// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__of30O","faq__title":"SectionFaq_faq__title__BvDdJ","faq__list-container":"SectionFaq_faq__list-container__ViDAe"};